import React from 'react'
import { connect } from 'react-redux'

import AlertBanner from 'components/alerts/alert-banner'
import ProfilePicture from 'components/profile/profile-picture'

import { formatByTimeZone } from 'utils'

const extractLinks = text => {
    if (!text) return []

    const parser = new DOMParser()
    const doc = parser.parseFromString(text, 'text/html')
    const anchors = Array.from(doc.querySelectorAll('a[href]'))

    return anchors
        .filter(a => !a.getAttribute('href').startsWith('#mention'))
        .map(a => ({
            href: a.getAttribute('href'),
            label: a.textContent.trim() || a.getAttribute('href'),
        }))
}

const SingleTaskLinks = ({ taskObject, allComments, allUsers }) => {
    const commentIds = taskObject.comments || []

    const linkItems = []

    commentIds.forEach(id => {
        const comment = allComments && allComments[id]
        if (!comment || comment.deleted_at) return

        const links = extractLinks(comment.text)
        const user = allUsers && allUsers[comment.user_id]

        links.forEach((link, i) => {
            linkItems.push({
                key: `${id}-${i}`,
                href: link.href,
                label: link.label,
                user,
                created_at: comment.created_at,
            })
        })
    })

    return (
        <div className="single-task-links">
            {!linkItems.length && (
                <AlertBanner
                    low={true}
                    title="No links yet."
                    body="Links shared in comments will appear here."
                />
            )}
            {linkItems.map(item => (
                <div className="single-task-link-item" key={item.key}>
                    <a href={item.href} target="_blank" rel="noopener noreferrer" className="link-url">
                        {item.label}
                    </a>
                    <div className="link-meta">
                        {item.user && (
                            <ProfilePicture user={item.user} size="tiny" />
                        )}
                        {item.created_at && (
                            <div className="link-meta-text">
                                <strong className="link-user">
                                    { item.user ? `${item.user.first_name} ${item.user.last_name}` : 'Unknown User' }
                                </strong>
                                <span className="link-date">
                                    {formatByTimeZone(item.created_at, 'Do MMM YYYY')}
                                </span>
                            </div>
                        )}
                    </div>
                </div>
            ))}
        </div>
    )
}

const mapStateToProps = state => ({
    allComments: state.account.entities.comments,
    allUsers: state.account.entities.users,
})

export default connect(mapStateToProps)(SingleTaskLinks)
